import { render, staticRenderFns } from "./SendTo.vue?vue&type=template&id=8a7f4bc6"
import script from "./SendTo.vue?vue&type=script&lang=js"
export * from "./SendTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports